module.exports = __webpack_public_path__ + "static/media/alerts-icon-complete.4fcc05e7.svg";